module.exports = __webpack_public_path__ + "img/icon-01.891a8c13.png";